export default {
  ADD_TEXT: 'text/ADD_TEXT',
  UPDATE_TEXT: 'text/UPDATE_TEXT',
  UPDATE_FONT: 'text/UPDATE_FONT',
  UPDATE_FONT_CATEGORY: 'text/UPDATE_FONT_CATEGORY',
  FONT_OUTLINE_UNSUPPORTED: 'text/FONT_OUTLINE_UNSUPPORTED',
  REPOSITION_FOR_TEXT_EFFECTS: 'text/REPOSITION_FOR_TEXT_EFFECTS',
  UPDATE_FONT_HEIGHT: 'text/UPDATE_FONT_HEIGHT',
  UPDATE_OUTLINE: 'text/UPDATE_OUTLINE',
  UPDATE_EFFECT: 'text/UPDATE_EFFECT',
  UPDATE_FIT_TO_DIMENSIONS: 'text/UPDATE_FIT_TO_DIMENSIONS',
  UPDATE_LAST_TEXT: 'text/UPDATE_LAST_TEXT',
  VERIFY_DIMENSIONS: 'text/VERIFY_DIMENSIONS',
  VERIFY_ERROR: 'text/VERIFY_ERROR',
  VERIFY_SUCCESS: 'text/VERIFY_SUCCESS'
};
